<template>
    <div data-component-name="one-card" class="one-card">
        <div v-if="cards && cards.length > 0" class="grid-container sticky-container" ref="stickyBar">
            <!-- Cards for sticky top -->
            <template v-for="(card, index) in cards"> 
                <!-- Remove card button -->
                <a href="javascript:void(0)" @click="removeCard(index)" class="grid-column-1 grid-row-1 remove-btn"><span class="remove lt-X"></span></a>
                
                <!-- Card image & card name -->
                <div class="image-container grid-column-1 grid-row-2">
                    <a :href="card.redirectLink" @click="trackCTA(index, 'Apply Now', 'Credit Card Apply Clicked')" target="_blank" rel="nofollow">
                        <img class="card-details-img" :src="card.imageUrl" width="156">
                    </a>
                </div>
                <a :href="card.redirectLink" @click="trackCTA(index, card.name, 'Credit Card Detail Clicked')" class="card-title grid-column-1 grid-row-3" target="_blank"><div v-html="card.name"></div></a>
                <div class="btn-container grid-column-1 grid-row-4">
                    <a :href="card.redirectLink" @click="trackCTA(index, 'Apply Now', 'Credit Card Apply Clicked')" class="btn btn-green" target="_blank" rel="nofollow">Apply Now <span class="lt-ExternalLink sm-icon"></span></a>
                </div>

                <p class="secure-site grid-column-1 grid-row-5 light">on {{ card.issuer.name}}'s secure site</p>
                <div class="rates-and-fees grid-column-1 grid-row-6">
                    <a :href="card.bankTermsUrl" @click="trackCTA(index, 'Rates & Fees', 'Credit Card Apply Clicked')" class="light" v-if="(card.bankTermPassback.toLowerCase() == 'yes' && card.issuer.ratesAndFeesIndicator)"  target="_blank">Rates &amp; Fees</a>
                    <p class="light" v-if="(card.bankTermPassback.toLowerCase() == 'yes' && card.issuer.ratesAndFeesTermsApplyIndicator)"> | Terms Apply</p>
                </div>

                <!-- Add additional cards placeholder -->
                <div class="add-cards">
                    <div class="dotted-line">
                        <span class="lt-CreditCards lg-icon"></span>
                        <p>Use the search bar to add another card to compare.</p>
                    </div>
                </div>
            </template>
        </div>
        <div class="grid-container">
            <!-- Cards -->
            <template v-for="(card, index) in cards">
                <!-- Card details -->
                <!-- Offer Valuation -->
                <div :class="`title-banner grid-row-7 grid-span-3`">
                    <div class="valuation-section-name">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="none">
                            <path d="M15.9301 0.000727925C15.1081 0.124775 9.6472 0.698285 5.62698 1.6841C-0.0988602 3.08823 0.00444315 7.78971 0.00444315 9.64795V11.8674C0.00305467 11.8693 0 15.8314 0 15.9276C0 16.0044 0.073312 16.0257 0.120798 15.9642C4.08381 10.778 8.2115 7.37331 8.2115 7.37331C8.2115 7.37331 8.23261 7.35227 8.1954 7.36074C7.82356 7.44626 5.77693 8.10993 3.27405 9.44193C3.27211 8.99056 3.27627 8.69574 3.27405 8.64328C3.25183 5.44239 5.16683 4.57788 7.45284 3.95301C9.31618 3.4437 12.7888 3.15217 12.7888 3.15217C12.7888 3.15217 12.5044 5.1473 12.1365 9.20969C11.8679 12.1775 9.65164 12.8404 6.56254 12.8404C6.20764 12.8404 5.68807 12.8409 4.81749 12.8412C3.41623 14.8106 3.24211 15.9954 3.24211 15.9954C3.24211 15.9954 6.06185 15.9937 6.65473 15.9937C13.1456 15.9937 14.5952 13.1795 14.9046 9.01405C15.2969 3.72213 15.8382 0.652383 15.9979 0.0747734C16.0092 0.0329691 15.9737 -0.00582961 15.9301 0.000727925Z" fill="#08C177"/>
                        </svg>
                        Offer Valuation
                        <div class="valuation-disclosure">
                            <a href="javascript:void(0)" class="info-tip" @click="toggleTooltip">
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 14.5C11.3137 14.5 14 11.8137 14 8.5C14 5.18629 11.3137 2.5 8 2.5C4.68629 2.5 2 5.18629 2 8.5C2 11.8137 4.68629 14.5 8 14.5ZM8 15.5C11.866 15.5 15 12.366 15 8.5C15 4.63401 11.866 1.5 8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 12.366 4.13401 15.5 8 15.5Z" fill="#0069BA"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 13.4551C7.58579 13.4551 7.25 13.1193 7.25 12.7051L7.25 7.08909C7.25 6.67487 7.58579 6.33909 8 6.33909C8.41421 6.33909 8.75 6.67487 8.75 7.08909L8.75 12.7051C8.75 13.1193 8.41421 13.4551 8 13.4551Z" fill="#0069BA"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 13.4551C7.58579 13.4551 7.25 13.1193 7.25 12.7051L7.25 7.08909C7.25 6.67487 7.58579 6.33909 8 6.33909C8.41421 6.33909 8.75 6.67487 8.75 7.08909L8.75 12.7051C8.75 13.1193 8.41421 13.4551 8 13.4551Z" fill="#0069BA"/>
                                    <ellipse cx="8" cy="4.375" rx="0.875" ry="0.875" transform="rotate(-180 8 4.375)" fill="#0069BA"/>
                                </svg>
                            </a>
                            <div class="tool-tip" v-show="showTooltip">
                                <div class="content">
                                    <p>Our valuation is an estimate only, based on LendingTree's analysis of average consumer spending habits using data provided by the Bureau of Labor Statistics and each card's unique rewards system. Actual results may vary.</p>
                                    <p>Note that monthly estimates only apply to usage across the first year. Monthly estimates may change after the first year.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <a href="javascript:void(0)" @click="valuation = !valuation" :class="`${valuation ? 'lt-Minus' : 'lt-Plus' } sm-icon toggle`"></a>
                </div>
                <div :class="`subtitle-banner sub-drawer-valuation grid-row-8 grid-span-3`" v-show="valuation"><span v-show="index == 0">Est. First Year Rewards</span></div>
                <p v-bind:tok="isCompliance ? `editorialContent.valuationHighlights.yearlyValuation.text` : null" :class="`co-field grid-column-1 sub-drawer-valuation grid-row-9`" v-show="valuation">{{ getValuationText(card) }}</p>

                <!-- Offer Summary -->
                <div :class="`title-banner grid-row-10 grid-span-3`">Offer Summary <a href="javascript:void(0)" @click="summary = !summary" :class="`${summary ? 'lt-Minus' : 'lt-Plus' } sm-icon toggle`"></a></div>
                <div :class="`subtitle-banner sub-drawer-summary grid-row-11 grid-span-3`" v-show="summary"><span v-show="index == 0">Credit Needed</span></div>
                <p v-bind:tok="isCompliance ? `creditNeeded` : null" :class="`co-field grid-column-1 sub-drawer-summary grid-row-12`" v-show="summary">{{ card.creditNeeded && card.creditNeeded.name ? card.creditNeeded.name : (card.creditNeeded.rating ? card.creditNeeded.rating : "See Terms") }}</p>
                <div :class="`subtitle-banner sub-drawer-summary grid-row-13 grid-span-3`" v-show="summary"><span v-show="index == 0">Annual Fee</span></div>
                <p v-bind:tok="isCompliance ? `annualFee.valueText` : null" :class="`co-field grid-column-1 sub-drawer-summary grid-row-14`" v-show="summary">{{ getFeeVal(card.annualFee.valueText) }}</p>
                <div :class="`subtitle-banner sub-drawer-summary grid-row-15 grid-span-3`" v-show="summary"><span v-show="index == 0">Welcome Offer</span></div>
                <p v-bind:tok="isCompliance ? `signUpBonus.valueText` : null" :class="`co-field grid-column-1 sub-drawer-summary grid-row-16`" v-show="summary" v-html="$options.filters.parsecontent(getRewardsVal(card.signUpBonus.valueText))"></p>
                <div :class="`subtitle-banner sub-drawer-summary grid-row-17 grid-span-3`" v-show="summary"><span v-show="index == 0">Rewards Rate</span></div>
                <div v-bind:tok="isCompliance ? `rewardsRate.valueText` : null" :class="`co-field grid-column-1 sub-drawer-summary grid-row-18`" v-show="summary">
                    <div
                        :ref="`rewardsText0`"
                        class="rewards-text"
                        :class="{ 'collapsed': !expandedStates[`rewards0`] && shouldTruncate[`rewards0`] }"
                        v-html="getRewardsTextOnly(card.rewardsRate.valueText)"
                    ></div>
                    <button
                        v-if="shouldTruncate[`rewards0`]"
                        @click="toggleRewardsText(0)"
                        class="expand-btn"
                        type="button"
                    >
                        {{ expandedStates[`rewards0`] ? 'Click to Collapse' : 'Click to Expand' }}
                    </button>
                    <span v-show="card.rewardsRate.best" class="best"> <span class="lt-Check"></span>Best</span>
                </div>

                <!-- APRs -->
                <div :class="`title-banner grid-row-19 grid-span-3`">APRs <a href="javascript:void(0)" @click="aprs = !aprs" :class="`${aprs ? 'lt-Minus' : 'lt-Plus' } sm-icon toggle`"></a></div>
                <div :class="`subtitle-banner sub-drawer-aprs grid-row-20 grid-span-3`" v-show="aprs"><span v-show="index == 0">Intro Purchase APR</span></div>
                <p v-bind:tok="isCompliance ? `introPurchaseApr.valueText` : null" :class="`co-field grid-column-1 sub-drawer-aprs grid-row-21`" v-show="aprs">{{ getFeeVal(card.introPurchaseApr.valueText) }}</p>
                <div :class="`subtitle-banner sub-drawer-aprs grid-row-22 grid-span-3`" v-show="aprs"><span v-show="index == 0">Ongoing Purchase APR</span></div>
                <p v-bind:tok="isCompliance ? `purchaseGoToRate.valueText` : null" :class="`co-field grid-column-1 sub-drawer-aprs grid-row-23`" v-show="aprs">{{ getFeeVal(card.purchaseGoToRate.valueText) }}</p>
                <div :class="`subtitle-banner sub-drawer-aprs grid-row-24 grid-span-3`" v-show="aprs"><span v-show="index == 0">Intro Balance Transfer APR</span></div>
                <p v-bind:tok="isCompliance ? `introBalanceTransferApr.valueText` : null" :class="`co-field grid-column-1 sub-drawer-aprs grid-row-25`" v-show="aprs">{{ getFeeVal(card.introBalanceTransferApr.valueText) }}</p>
                <div :class="`subtitle-banner sub-drawer-aprs grid-row-26 grid-span-3`" v-show="aprs"><span v-show="index == 0">Ongoing Balance Transfer APR</span></div>
                <p v-bind:tok="isCompliance ? `balanceTransferGoToRate.valueText` : null" :class="`co-field grid-column-1 sub-drawer-aprs grid-row-27`" v-show="aprs">{{ getFeeVal(card.balanceTransferGoToRate.valueText) }}</p>

                <!-- Additional Card Details -->
                <div :class="`title-banner grid-row-28 grid-span-3`">Additional Card Details <a href="javascript:void(0)" @click="details = !details" :class="`${details ? 'lt-Minus' : 'lt-Plus' } sm-icon toggle`"></a></div>
                <div :class="`subtitle-banner sub-drawer-details grid-row-29 grid-span-3`" v-show="details"><span v-show="index == 0">Foreign Transaction Fee</span></div>
                <p v-bind:tok="isCompliance ? `foreignExchangeFee.valueText` : null" :class="`co-field grid-column-1 sub-drawer-details grid-row-30`" v-show="details">{{ getFeeVal(card.foreignExchangeFee.valueText) }}</p>
                <div :class="`subtitle-banner sub-drawer-details grid-row-31 grid-span-3`" v-show="details"><span v-show="index == 0">Balance Transfer Fee</span></div>
                <p v-bind:tok="isCompliance ? `balanceTransferFee.valueText` : null" :class="`co-field grid-column-1 sub-drawer-details grid-row-32`" v-show="details">{{ getFeeVal(card.balanceTransferFee.valueText) }}</p>
                <div :class="`subtitle-banner sub-drawer-details grid-row-33 grid-span-3`" v-show="details"><span v-show="index == 0">More Details</span></div>
                <a :href="card.detailsUrl" @click="trackCTA(index, card.name, 'Credit Card Detail Clicked')" :class="`grid-column-1 sub-drawer-details grid-row-34`" v-show="details" target="_blank">More Details</a>
            </template>
        </div>
    </div>
</template>
<style src="../../shared/sass/saved-cards/one-card.scss" lang="scss"></style>
<script>
    import ExpandableTextMixin from '../../shared/mixins/expandable-text';

    export default {
        name: "one-card",
        mixins: [ExpandableTextMixin],
        props: {
            cards: {
                type: Array,
                // Object or array defaults must be returned from
                // a factory function
                default: () => [],
                required: true
            },
            isSticky: Function,
            isCompliance: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            getValuationText(card) {
                const valuation = card.editorialContent?.valuationHighlights?.yearlyValuation;
                if (!valuation || !card.valuationComponentIndicator) return 'N/A';

                if (card.limitedTimeOfferActiveIndicator && valuation.limitedTimeOfferOverride) {
                    return valuation.limitedTimeOfferOverride;
                }

                return valuation.text;
            },
            toggleTooltip() {
                this.showTooltip = !this.showTooltip;
            },
            removeCard: function (index) {
                var cardIdValue = this.cards[index].cardId;
                var savedCreditCards = localStorage.getItem('cardItems') ? JSON.parse(localStorage.getItem('cardItems')) : [];
                var indexOfSession = savedCreditCards.findIndex(card => card.cardId == cardIdValue);
                if (indexOfSession != -1) {
                    savedCreditCards.splice(indexOfSession, 1);
                    localStorage.setItem('cardItems', JSON.stringify(savedCreditCards));
                }
                this.cards.splice(index, 1);
                this.$emit('card-removed', this.cards);
            },
            trackCTA: function (index, buttonText, eventName) {
                var card = this.cards[index];
                var position = ++index;
                var category = this.$analyticsService.getCategoryName();

                var clickoutID = this.pageRequestId + '-' + card.legacyId + '-' + position;
                var trackData = { clickoutid: clickoutID, creditCard_data: [], cta_clicked: buttonText };
                var trackCard = {
                    card_bt_passback: card.bankTermPassback,
                    card_id: card.cardId,
                    card_page: location.href,
                    card_position: position,
                    card_section: category,
                    category: category,
                };
                trackData.creditCard_data.push(trackCard);
                this.$analyticsService.trackCTA(trackData, eventName);
            },
        },
        data: function () {
            return {
                valuation: true,
                summary: true,
                aprs: true,
                details: true,
                showTooltip: false,
                scrollThrottle: null,
            }
        },
        updated: function() {
            if (this.scrollThrottle) {
                clearTimeout(this.scrollThrottle);
            }
            const throttledScrollHandler = () => {
                if (this.scrollThrottle) return;
                this.scrollThrottle = setTimeout(() => {
                    this.isSticky(this.$refs.stickyBar);
                    this.scrollThrottle = null;
                }, 16);
            };
            window.addEventListener('scroll', throttledScrollHandler);
        },
        beforeDestroy: function() {
            if (this.scrollThrottle) {
                clearTimeout(this.scrollThrottle);
            }
        },
    }
</script>
